import { render, staticRenderFns } from "./ModalAddTypeWeight.vue?vue&type=template&id=1ce0aaf5"
import script from "./ModalAddTypeWeight.vue?vue&type=script&lang=js"
export * from "./ModalAddTypeWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports